<script>
    import {_, locale} from 'svelte-i18n';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem } = $props();
    let itemDetails = $state({});

    function setItemDetails() {
        itemDetails.title = $_("ResetHeroSkillTreeItem");
        itemDetails.description = $_("ResetHeroSkillTreeItemDescription");

        itemDetails.amount = item.amount;
        itemDetails.icon = "resetHeroSkillTree";

        itemDetails.rarity = gameItem.rarity;
        itemDetails.expireAt = $gameConfig?.temporaryItems?.[item.id];
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
